import React, { Component } from 'react';
//import logo from './logo.svg';
import { connect } from 'react-redux'
import { initLocation } from './actions'
import {
  Redirect
} from "react-router-dom";

// import { Row, Input, Dropdown, Button} from 'react-materialize';


class RedSocial extends Component {
  constructor(props){
    super(props)
    this.state = {
      country: '' ,
      searchico: false,
      searchmovile: false,
      urlsend:'',
      redirect:false,
      optionsli:{
        hover: false,
        closeOnClick: false,
        constrainWidth : true,
        alignment: 'right',
        draggable: true
      },
    }
    this.handleBlur = this.handleBlur.bind(this)
    this.onKeypress = this.onKeypress.bind(this)
  }

  componentWillReceiveProps(next_props) {
    if(next_props.country.location !== this.state.country){
      if(next_props.country.location !== undefined || next_props.country.location !== 'undefined'){
        let stringGeo = (next_props.country.location)?next_props.country.location.toLowerCase():''
        this.setState({
          country: stringGeo
        });
      }
    }

    if(next_props.search !== this.state.searchico){
      this.setState({
        searchico: next_props.search
      });
    }

  }

  handleBlur(event) {
    if(event.currentTarget.value !== ''){
      event.currentTarget.value = '';
    }
  }

  onKeypress(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      let url = `/search/${event.currentTarget.value}`
      this.setState({
        urlsends: url,
        redirect: true
      });
    }
  }


  render() {
    if (this.state.redirect) {
      return (
        <div className="socialChannel">
          <a href="https://www.facebook.com/VCMultichannel/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
          <a href="https://www.instagram.com/vcmultichannelco/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
          <Redirect to={this.state.urlsends} />
        </div>
      );

    }
    if(this.state.country === 'cent'){
      return (
        <div className="socialChannel">
          <a href="https://www.facebook.com/VCMultichannel/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
          <a href="https://www.instagram.com/vcmultichannelcam/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
          {
            this.state.searchico &&
            <div className="search-ico">
              <form className="fas" id="form-search">
                <input type="search" placeholder="Search" onBlur={this.handleBlur} onKeyPress={this.onKeypress}/>
              </form>
            </div>
          }
        </div>
      );
    }
    if(this.state.country === 'co'){
      return (
        <div className="socialChannel">
          <a href="https://www.facebook.com/VCMultichannel/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
          <a href="https://www.instagram.com/vcmultichannelco/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
          <a href="https://www.youtube.com/channel/UCOVDNT_yw8U7cX5KYMNFVlg" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
          <a href="https://www.linkedin.com/company/vcmultichannel/?viewAsMember=true" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
          {
            this.state.searchico &&
            <div className="search-ico">
              <form className="fas" id="form-search">
                <input type="search" placeholder="Search" onBlur={this.handleBlur} onKeyPress={this.onKeypress}/>
              </form>
            </div>
          }
        </div>
      );
    }
    if(this.state.country === 've'){
      return (
        <div className="socialChannel">
          <a href="https://www.facebook.com/VCMultichannelVE/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
          <a href="https://www.instagram.com/vcmultichannelve/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
          <a href="https://twitter.com/vcmultichannelv" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
          {
            this.state.searchico &&
            <div className="search-ico">
              <form className="fas" id="form-search">
                <input type="search" placeholder="Search" onBlur={this.handleBlur} onKeyPress={this.onKeypress}/>
              </form>
            </div>
          }
        </div>
      );
    }
    if(this.state.country === 'ar'){
      return (
        <div className="socialChannel">
          <a href="https://www.facebook.com/VCMARGENTINA/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
          <a href="https://www.instagram.com/vcmargentina/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
          <a href="https://twitter.com/VCMArgentina" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
          {
            this.state.searchico &&
            <div className="search-ico">
              <form className="fas" id="form-search">
                <input type="search" placeholder="Search" onBlur={this.handleBlur} onKeyPress={this.onKeypress}/>
              </form>
            </div>
          }
        </div>
      );
    }
    if(this.state.country === 'cl'){
      return (
        <div className="socialChannel">
          <a href="https://www.facebook.com/VC-Multichannel-Chile-1118660731544189/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
          <a href="https://www.instagram.com/vcmultichannelchile/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
          {
            this.state.searchico &&
            <div className="search-ico">
              <form className="fas" id="form-search">
                <input type="search" placeholder="Search" onBlur={this.handleBlur} onKeyPress={this.onKeypress}/>
              </form>
            </div>
          }
        </div>
      );
    }
    if(this.state.country === 'do'){
      return (
        <div className="socialChannel">
          <a href="https://www.facebook.com/VCMultiRD/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
          <a href="https://www.instagram.com/vcmultichannelrd/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
          <a href="https://www.youtube.com/channel/UCOVDNT_yw8U7cX5KYMNFVlg" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
          {
            this.state.searchico &&
            <div className="search-ico">
              <form className="fas" id="form-search">
                <input type="search" placeholder="Search" onBlur={this.handleBlur} onKeyPress={this.onKeypress}/>
              </form>
            </div>
          }

          {
            !this.state.searchico &&
            <a href="/search" className="search-ico hide-on-large-and-up"><i className="fas" id="form-search"></i></a>
          }
        </div>
      );
    }

    return (
        <div className="socialChannel">
          <a href="https://www.facebook.com/VCMultichannel/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
          <a href="https://www.instagram.com/vcmultichannelco/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>

          {
            this.state.searchico &&
            <div className="search-ico">
              <form className="fas" id="form-search">
                <input type="search" placeholder="Search" onBlur={this.handleBlur} onKeyPress={this.onKeypress}/>
              </form>
            </div>
          }

          {
            !this.state.searchico &&
            <a href="/search" className="search-ico hide-on-large-and-up"><i className="fas" id="form-search"></i></a>
          }
        </div>
      );
  }
}

function mapStateToProps (reducer){
  return {
    country: reducer.country
  }
}

function mapDispathToProps (dispatch){
  return {
    getLocation: (data) => dispatch(initLocation(data)),
  }
}

export default connect(mapStateToProps, mapDispathToProps)(RedSocial)



// WEBPACK FOOTER //
// ./src/redsocial.js